import React, { useState, useEffect } from "react";
import "../../styles/AddVendor.css";
import AsyncSelect from 'react-select/async';
import axiosInstance from "../../axiosInstance";
import { ToastContainer, toast } from 'react-toastify';

const AddVendor = ({ onClose, jobData }) => {
  const [selectedVendor, setSelectedVendor] = useState(null);
  const [selectedVendors, setSelectedVendors] = useState({});
  const [isAllCheckedMap, setIsAllCheckedMap] = useState({});
  const [tableData, setTableData] = useState([]);

  useEffect(() => {
    if (jobData) {
      const defaultSelection = {};
      const headerCheckState = {};

      jobData.forEach(job => {
        let allChecked = true;
        job.chargelines?.forEach(line => {
          defaultSelection[line.job_line_id] = true;
        });

        allChecked = job.chargelines?.every(line => defaultSelection[line.job_line_id]);
        headerCheckState[job.job_id] = allChecked;
      });

      setSelectedVendors(defaultSelection);
      setIsAllCheckedMap(headerCheckState);
      setTableData(jobData);
    }
  }, [jobData]);



  const loadVendorOptions = async (inputValue, callback) => {
    try {
      const res = await axiosInstance.get("/vendor/autosuggestion", {
        params: { term: inputValue || '' }
      });

      const data = res.data;

      if (data.success && Array.isArray(data.autosuggestion)) {
        const mapped = data.autosuggestion.map((item) => ({
          label: item.label,
          value: item.value,
        }));

        callback(mapped);
      } else {
        callback([]);
      }
    } catch (error) {
      console.error("Vendor suggestion error:", error);
      callback([]);
    }
  };

  const handleVendorChange = (selected) => {
    const newVendor = {
      vendor_id: selected?.value || '',
      vendor_name: selected?.label || ''
    };
    setSelectedVendor(newVendor);

    if (selected) {
      setTableData(prevData => {
        return prevData.map(job => ({
          ...job,
          chargelines: job.chargelines?.map(line => {
            if (selectedVendors[line.job_line_id]) {
              return {
                ...line,
                vendor_id: newVendor.vendor_id,
                vendor_name: newVendor.vendor_name
              };
            }
            return line;
          })
        }));
      });
    }
  };

  const handleSaveVendor = async () => {
    if (!selectedVendor) {
      toast.warning("Please select a vendor first");
      return;
    }

    const selectedJobLineIds = Object.entries(selectedVendors)
      .filter(([_, isSelected]) => isSelected)
      .map(([jobLineId]) => parseInt(jobLineId));

    if (selectedJobLineIds.length === 0) {
      toast.warning("Please select at least one job line");
      return;
    }

    try {
      const response = await axiosInstance.post("/job/bulkjobline_vendor_update", {
        job_cost_line_ids: selectedJobLineIds,
        vendor_id: selectedVendor.vendor_id
      });

      if (response.data.success) {
        toast.success("Vendor updated successfully");
        onClose({
          updated: true,
          vendorId: selectedVendor.vendor_id,
          vendorName: selectedVendor.vendor_name,
          jobLineIds: selectedJobLineIds
        });
      } else {
        toast.error("Failed to update vendor: " + (response.data.message || "Unknown error"));
      }
    } catch (error) {
      console.error("Error updating vendor:", error);
      toast.error("An error occurred while updating the vendor");
    }
  };

  return (
    <>
      <div className="add-vendor-popup-wrapper">
        <div className="add-vendor-popup-content" style={{
          maxHeight: '90vh',
          display: 'flex',
          flexDirection: 'column'
        }}>
          {/* Header */}
          <div className="add-vendor-popup-header">
            <h3>Add Vendor</h3>
            <button onClick={onClose}>X</button>
          </div>

          {/* Body */}
          <div className="add-vendor-popup-body" style={{
            flex: 1,
            overflowY: 'auto',
          }}>
            <label htmlFor="vendor-name">Vendor</label>
            <AsyncSelect
              id="vendor-name"
              cacheOptions
              defaultOptions
              loadOptions={loadVendorOptions}
              placeholder="Select Vendor"
              onChange={handleVendorChange}
              styles={{
                control: (base, state) => ({
                  ...base,
                  minHeight: '40px',
                  borderRadius: '12px',
                  fontSize: '14px',
                  width: '100%',
                  borderColor: state.isFocused ? '#454CF2' : '#DCDFE4',
                  boxShadow: state.isFocused ? '0 0 0 1px #454CF2' : 'none',
                  '&:hover': {
                    borderColor: '#454CF2'
                  },
                }),
                container: (base) => ({
                  ...base,
                  width: '350px',
                }),
                menu: (base) => ({
                  ...base,
                  zIndex: 999,
                  fontSize: '13px',
                  marginTop: '4px',
                  boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                }),
              }}
            />

            <div className="invoice_popup_categories" style={{ marginTop: '0px', padding: '0px' }}>
              {tableData?.map(job => (
                <div className="invoice_popup_outercategory" key={job.job_id}>
                  <div className="job-section">
                    <div className="invoice_popup_category_header" style={{ padding: '8px', paddingBottom: '1px' }}>
                      <span className="category_name">Job: {job.job_no} - {job.project_name}</span>
                    </div>
                    <div className="invoice_popup_category_subheader">
                      <div className="invoice_popup_element_list" style={{ overflowX: "auto", paddingTop: '0px', paddingBottom: '0px' }}>
                        <div style={{ overflowX: 'auto', whiteSpace: 'nowrap', scrollbarWidth: 'none', OverflowStyle: 'none', WebkitOverflowScrolling: 'touch', scrollBehavior: 'smooth' }}>
                          <table className="vendor-assignment-table" >
                            <thead>
                              <tr>
                                <th rowSpan="2">
                                  <input
                                    type="checkbox"
                                    checked={!!isAllCheckedMap[job.job_id]}
                                    onChange={(e) => {
                                      const checked = e.target.checked;
                                      const updatedSelection = { ...selectedVendors };

                                      job.chargelines?.forEach(line => {
                                        updatedSelection[line.job_line_id] = checked;
                                      });

                                      setSelectedVendors(updatedSelection);
                                      setIsAllCheckedMap(prev => ({
                                        ...prev,
                                        [job.job_id]: checked
                                      }));
                                    }}
                                  />

                                </th>

                                <th colSpan="11" style={{ padding: '10px', fontSize: '12px', color: '#097BED' }}>COST</th>
                              </tr>
                              <tr>
                                <th style={{ fontSize: '12px', padding: '10px' }}>Charge Code</th>
                                <th style={{ fontSize: '12px' }}>Description</th>
                                <th style={{ fontSize: '12px' }}>PO/WO Number</th>
                                <th style={{ fontSize: '12px' }}>PO/WO Date</th>
                                <th style={{ fontSize: '12px' }}>Vendor</th>
                                <th style={{ fontSize: '12px' }}>Remarks</th>
                                <th style={{ fontSize: '12px' }}>Accrual Split</th>
                                <th style={{ fontSize: '12px' }}>Contract Value</th>
                                <th style={{ fontSize: '12px' }}>Quantity</th>
                                <th style={{ fontSize: '12px' }}>Rate</th>
                                <th style={{ fontSize: '12px' }}>Net Total</th>
                              </tr>
                            </thead>
                            <tbody>
                              {job.chargelines?.map(chargeLine => (
                                <tr key={chargeLine.job_line_id}>
                                  <td>
                                    <input
                                      type="checkbox"
                                      checked={!!selectedVendors[chargeLine.job_line_id]}
                                      onChange={(e) => {
                                        const checked = e.target.checked;
                                        const updated = {
                                          ...selectedVendors,
                                          [chargeLine.job_line_id]: checked
                                        };
                                        setSelectedVendors(updated);

                                        const allSelected = job.chargelines?.every(line => updated[line.job_line_id]);
                                        setIsAllCheckedMap(prev => ({
                                          ...prev,
                                          [job.job_id]: allSelected
                                        }));
                                      }}
                                    />

                                  </td>
                                  <td style={{ padding: '10px' }}>{chargeLine.charge_code}</td>
                                  <td>{chargeLine.description_of_charges}</td>
                                  <td>{chargeLine.cost_po_wo_number}</td>
                                  <td>{chargeLine.cost_po_wo_date}</td>
                                  <td>{chargeLine.vendor_name}</td>
                                  <td>{chargeLine.cost_remarks}</td>
                                   <td>{chargeLine.cost_accrual}</td>
                                  <td>{chargeLine.cost_contract_value}</td>
                                  <td>{chargeLine.cost_unit_of_quantity}</td>
                                  <td>{chargeLine.cost_unit_of_rate}</td>
                                  <td>{chargeLine.cost_net_total}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Footer (Save button) */}
          <div className="add-vendor-popup-footer" style={{ padding: '10px', textAlign: 'right' }}>
            <button className="existing-job-add-btn" onClick={handleSaveVendor}>
              Save Vendor
            </button>
          </div>
        </div>
      </div>
      <ToastContainer position="top-right" autoClose={2000} hideProgressBar={false} />
    </>
  );
};

export default AddVendor;